export default {
	api: 'https://laundry.ust.hk/ldr/api',
	loginTimeout: 86400
};
